import styled, { css } from 'styled-components'

const textDefaultProps = props => css`
  text-align: ${props.align};
  letter-spacing: ${props.letterSpacing};

  margin: ${props.margin || '0.5rem 0'};
  margin-top: ${props.marginTop};
  margin-bottom: ${props.marginBottom};
  margin-left: ${props.marginLeft};
  margin-right: ${props.marginRight};

  padding: ${props.padding};
  padding-top: ${props.paddingTop};
  padding-bottom: ${props.paddingBottom};
  padding-left: ${props.paddingLeft};
  padding-right: ${props.paddingRight};

  font-size: ${props.size};
  font-weight: ${props.weight};
  font-style: ${props.fontStyle};
  color: ${props.color};
`

export const Heading = styled.h1`
  font-family: 'Dustismo Roman', sans-serif;
  font-weight: ${props => props.weight || '700'};
  line-height: 1.25;

  ${textDefaultProps}
`

export const Text = styled.div`
  font-family: 'Dustismo Roman', sans-serif;
  line-height: 1.3;
  ${textDefaultProps}
`
